export const CARDS_BLOCK_b12 =  {
  "blockType": "CARDS",
  "blockDesign": "BYOCards",
  "editFormName": "DESIGN_CARD_PANEL",
  "styleProps": {
    "background-color": "",
    "padding": "120px 20px 120px 20px",
    "background-image": "linear-gradient(to bottom,#F4ECEA,#E0DEE9)",
    "background-repeat": "",
    "background-position": "center",
    "background-size": "cover"
  },
  "headings": [
    {
      "text": "Our Leadership Team",
      "styleProps": {
        "text-align": "center",
        "color": "#939393",
        "font-size": "3.75rem",
        "line-height": "1",
        "font-weight": "600"
      },
      "stylePropsTab": {
        "font-size": "3rem",
        "line-height": "1"
      },
      "stylePropsMob": {
        "font-size": "1.875rem",
        "line-height": "2.25rem"
      }
    },
    {
      "text": "Meet the visionaries behind our company:",
      "styleProps": {
        "color": "#939393",
        "font-size": "1.5rem",
        "line-height": "2rem",
        "margin": "30px 0px 50px 0px",
        "text-align": "center"
      },
      "stylePropsTab": {
        "font-size": "1.25rem",
        "line-height": "1.75rem",
        "margin": "30px 0px 40px 0px"
      },
      "stylePropsMob": {
        "font-size": "1.125rem",
        "line-height": "1.75rem"
      }
    }
  ],
  "cardElements": [
    {
      "type": "text",
      "id": 1747058653860,
      "elIndex": 0,
      "text": "[[id]]",
      "params": [
        {
          "value": "id",
          "label": "id"
        }
      ],
      "styleProps": {
        "color": "#939393",
        "font-size": "3.75rem",
        "line-height": "1",
        "font-family-bk": "'Anton', sans-serif",
        "font-family": "'Anton', sans-serif",
        "margin": "0px 0px 60px 0px",
        "border-width": "0px 0px 2px 0px",
        "border-color": "#ffa611",
        "padding": "0px 0px 20px 0px"
      },
      "location": "A",
      "stylePropsTab": {
        "margin": "0px 0px 40px 0px"
      },
      "stylePropsMob": {
        "margin": "0px 0px 30px 0px"
      }
    },
    {
      "type": "text",
      "id": 1746529638292,
      "elIndex": 1,
      "text": "[[name]]",
      "location": "A",
      "params": [
        {
          "value": "name",
          "label": "name"
        }
      ],
      "styleProps": {
        "color": "",
        "font-size": "2.25rem",
        "line-height": "2.5rem",
        "font-weight": "900",
        "font-family-bk": "'Lato', sans-serif",
        "font-family": "'Lato', sans-serif",
        "font-family-cust": "",
        "padding": "0px 0px 8px 0px"
      },
      "stylePropsTab": {
        "font-size": "1.5rem",
        "line-height": "2rem",
        "padding": "0px 0px 0px 0px"
      },
      "stylePropsMob": {
        "font-size": "1.5rem",
        "line-height": "2rem",
        "padding": "0px 0px 0px 0px"
      },
      "fonts": {
        "styleProps": ""
      }
    },
    {
      "type": "text",
      "id": 1746533060416,
      "elIndex": 2,
      "text": "[[role]]",
      "location": "A",
      "params": [
        {
          "value": "role",
          "label": "role"
        }
      ],
      "styleProps": {
        "padding": "0px 0px 16px 0px",
        "text-align": "left",
        "color": "",
        "font-size": "1.25rem",
        "line-height": "1.75rem",
        "font-weight": "400"
      },
      "stylePropsTab": {
        "font-size": "1.25rem",
        "line-height": "1.75rem",
        "padding": "0px 0px 10px 0px"
      },
      "stylePropsMob": {
        "font-size": "1rem",
        "line-height": "1.5rem",
        "padding": "0px 0px 4px 0px"
      }
    },
    {
      "type": "text",
      "id": 1746622309663,
      "elIndex": 3,
      "text": "[[description]]",
      "params": [
        {
          "value": "description",
          "label": "description"
        }
      ],
      "location": "A",
      "styleProps": {
        "text-align": "left",
        "margin": "0px 0px 0px 0px",
        "border-width": "0px",
        "border-color": "#116dff",
        "color": ""
      },
      "stylePropsTab": {
        "margin": "0px 0px 0px 0px"
      },
      "stylePropsMob": {
        "margin": "0px 0px 0px 0px"
      }
    },
    {
      "type": "button",
      "id": 1747059468510,
      "elIndex": 4,
      "text": "View Profile",
      "location": "C",
      "btnStyleProps": {
        "border-width": "0px",
        "padding": "10px 0px 10px 0px",
        "color": ""
      },
      "styleProps": {
        "background-color": ""
      }
    }
  ],
  "cardConfig": {
    "perRow": {
      "mobile": 1,
      "tab": 1,
      "desktop": 3
    },
    "layout": "l5",
    "cardstyleProps": {
      "padding": "24px 12px 24px 12px"
    },
    "cardstylePropsTab": {
      "padding": "24px 12px 14px 12px"
    },
    "cardstylePropsMob": {
      "padding": "0px 0px 8px 0px"
    }
  },
  "configs": {
    "dataType": "dynamic",
    "connection": {
      "spreadsheetId": "",
      "sheetName": "",
      "connectionId": "",
      "connectionTable": "",
      "timestamp": 1747061981642
    },
    "params": [],
    "filters": {
      "categories": []
    },
    "searchConfig": {
      "showSearchBar": false,
      "searchButton": {
        "styleProps": {
          "color": "#ffffff",
          "padding": "5px 20px 5px 20px",
          "background-color": "#333333",
          "border-radius": "1.5rem",
          "margin": "0px 10px 0px 10px",
          "font-weight": "bold",
          "width": "auto"
        },
        "stylePropsMob": {
          "width": "auto"
        }
      },
      "clearButton": {
        "styleProps": {
          "background-color": "#ececec",
          "color": "#333333",
          "padding": "5px 20px 5px 20px",
          "border-radius": "9999px"
        }
      },
      "searchContainer": {
        "styleProps": {
          "background-color": "#ececec",
          "border-radius": "1.5rem",
          "padding": "10px 20px 10px 10px",
          "margin": "30px 0px 30px 0px",
          "width": "auto"
        },
        "stylePropsTab": {
          "border-radius": "9999px"
        },
        "stylePropsMob": {
          "border-radius": "1rem",
          "width": "100%"
        }
      },
      "input": {
        "styleProps": {
          "border-radius": "9999px",
          "padding": "5px 20px 5px 20px",
          "color": "#333333",
          "font-weight": "100",
          "background-color": "#ffffff",
          "width": "auto"
        },
        "stylePropsMob": {
          "margin": "0px 0px 10px 0px",
          "width": "100%"
        }
      }
    },
    "sortBy": {
      "columnName": "",
      "ascending": true
    },
    "id": "1723883803066"
  },
  "metaDataId": 1747058445681,
  "afterIndex": 7,
  "blockId": 1747058445681,
  "stylePropsTab": {
    "padding": "80px 20px 80px 20px"
  },
  "stylePropsMob": {
    "padding": "60px 10px 60px 10px"
  },
  "cardLocations": [
    {
      "name": "outer",
      "styleProps": {
        "background-image": "url('')",
        "border-radius": "0.75rem",
        "padding": "0px 0px 0px 0px",
        "background-repeat": "no-repeat",
        "background-size": "cover",
        "background-color": "#ffffff"
      },
      "stylePropsMob": {
        "padding": "0px 0px 0px 0px"
      }
    },
    {
      "name": 0
    },
    {
      "name": "A",
      "styleProps": {
        "background-color": "",
        "margin": "0px 0px 0px 0px",
        "border-radius": "0px",
        "padding": "0px 0px 0px 0px",
        "box-shadow": "",
        "alignItems": "",
        "justify-content": "",
        "flex-direction": "",
        "display": "block",
        "width": "100%",
        "text-align": "left",
        "background-image": "url('')",
        "background-repeat": "no-repeat",
        "background-position": "center",
        "background-size": "cover",
        "color": "#939393"
      },
      "stylePropsTab": {
        "padding": "0px 0px 0px 0px"
      },
      "stylePropsMob": {
        "padding": "0px 0px 0px 0px"
      },
      "innerDiv": {
        "styleProps": {
          "height": "auto",
          "display": "flex",
          "justify-content": "flex-start",
          "background-image": "url('')",
          "padding": "40px 40px 10px 40px",
          "border-radius": "0px",
          "margin": "0px 0px 0px 0px",
          "alignItems": "flex-start",
          "background-repeat": "no-repeat",
          "background-position": "center"
        },
        "stylePropsTab": {
          "height": "auto",
          "padding": "30px 30px 10px 30px",
          "margin": "0px 0px 0px 0px"
        },
        "stylePropsMob": {
          "height": "auto",
          "background-size": "cover",
          "margin": "0px 0px 0px 0px",
          "padding": "20px 20px 10px 20px"
        }
      }
    },
    {
      "name": "B",
      "styleProps": {
        "padding": "40px 40px 20px 40px",
        "display": "flex",
        "flex-direction": "column",
        "justify-content": "center",
        "width": "100%",
        "alignItems": "",
        "text-align": "center",
        "box-shadow": ""
      },
      "innerDiv": {
        "styleProps": {
          "justify-content": "left",
          "alignItems": "flex-start",
          "background-image": "url('[[img]]')",
          "height": "320px",
          "padding": "0px 0px 0px 0px",
          "box-shadow": "0 34px 50px -34px rgb(0 0 0 / 0.25)",
          "border-radius": "1rem"
        },
        "stylePropsTab": {
          "height": "320px"
        },
        "stylePropsMob": {
          "height": "256px"
        }
      },
      "stylePropsMob": {
        "padding": "30px 20px 10px 20px"
      },
      "stylePropsTab": {
        "padding": "30px 30px 10px 30px"
      }
    },
    {
      "name": "C",
      "styleProps": {
        "width": "100%",
        "display": "flex",
        "flex-direction": "row",
        "alignItems": "center",
        "justify-content": "center",
        "text-align": "center",
        "border-color": "#33333333",
        "border-width": "0px",
        "padding": "0px 0px 0px 0px",
        "color": "#939393"
      },
      "innerDiv": {
        "styleProps": {
          "width": "100%",
          "display": "flex",
          "flex-direction": "row",
          "alignItems": "flex-start",
          "justify-content": "flex-start",
          "padding": "10px 40px 30px 40px"
        },
        "stylePropsMob": {
          "padding": "10px 20px 30px 20px"
        }
      },
      "stylePropsTab": {
        "padding": "0px 0px 0px 0px"
      }
    }
  ],
  "overlay": {
    "styleProps": {
      "background-color": ""
    }
  },
  "containerStyleProps": {
    "max-width": "1280px"
  }
}